// removing the "Visualize", "Explore", "Create" text from the title. Makes first letter uppercase.
export const makeTitle = (title: string) => {
  return title
    .replace('Detailed image in natural colors depicting', '')
    .replace('Create a visual narrative of ', '')
    .replace('Detailed visual representation of ', '')
    .replace('An image depicting', '')
    .replace('Please create', '')
    .replace('Create an image illustrating', '')
    .replace('A surreal visualization where', '')
    .replace('Produce an imaginative and unique image representing', '')
    .replace('Depict a scene wher', '')
    .replace('Generate an image of', '')
    .replace('Generate a detailed', '')
    .replace('A vivid depiction of', '')
    .replace('An image detailing', '')
    .replace('A detailed ', '')
    .replace('Imagine a design that glorifies', '')
    .replace('Imagine a vibrant scene showcasing ', '')
    .replace('An illustration of', '')
    .replace('Create an image that symbolizes', '')
    .replace('An image of', '')
    .replace('A detailed illustration depicting', '')
    .replace('Visualize', '')
    .replace('Visualise', '')
    .replace('Imagine', '')
    .replace('Create an image of', '')
    .replace('Generate', '')
    .replace('Explore', '')
    .replace('Creating a detailed image of', '')
    .replace('Create', '')
    .replace('Illustrate', '')
    .replace('Represent', '')
    .replace('Envision', '')
    .replace('Design', '')
    .replace('Imagine', '')
    .replace('An image showcasing a visual representation of', '')
    .replace('Produce An Image Of', '')
    .replace('An image that illustrates', '')
    .replace('Produce', '')
    .replace('Design An Image Capturing', '')
    .replace('An image', '')
    .replace('an imagery capturing', '')
    .replace('Capture', '')
    .split(' ')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
    .split('. ')[0];
};
